/**
 * The schedule for polling GET /chat/history (operator replies).
 *
 * The API stage is throttled as an AGGREGATE — 5 requests/second across every
 * visitor of every tenant — and the old widget polled every 5 seconds for as
 * long as a panel stayed open, so 25 idle tabs saturated the whole product
 * (review B3). Operator replies are rare and, when they come, come soon after
 * the visitor wrote. So:
 *
 *   - 5 s while the visitor was active in the last 2 minutes ("hot"),
 *   - then each wait doubles — 10, 20, 40 — capped at 60 s,
 *   - and after 15 minutes idle polling stops until the next send, open or
 *     return to the tab.
 *
 * Pure so scripts/test-config.mjs can pin the numbers.
 */

export const HOT_POLL_MS = 5_000;
export const HOT_WINDOW_MS = 2 * 60_000;
export const MAX_POLL_MS = 60_000;
export const IDLE_STOP_MS = 15 * 60_000;

/**
 * Milliseconds until the next poll, given how long the visitor has been idle
 * and the previous wait — or null to stop polling.
 */
export function nextPollDelay(idleMs: number, previousMs: number): number | null {
  if (idleMs >= IDLE_STOP_MS) return null;
  if (idleMs < HOT_WINDOW_MS) return HOT_POLL_MS;
  const base = Number.isFinite(previousMs) && previousMs > 0 ? previousMs : HOT_POLL_MS;
  return Math.min(MAX_POLL_MS, base * 2);
}
